module.exports = __webpack_public_path__ + "static/media/bg.5cf54274.jpg";